import {DeepPartial} from '@fluentui/merge-styles';
import {IDetailsListStyles, IDetailsRowStyles} from 'components/FluentUICompat';

type EntityListStyles = DeepPartial<IDetailsListStyles>;

export const entityListStylesWithAutoOverflowX: EntityListStyles = {
	root: {overflowX: 'auto'},
};

export const getStylesForRowBgColor = (
	backgroundColor: string | undefined,
): Partial<IDetailsRowStyles> => {
	return {root: {backgroundColor, '&:hover': {backgroundColor}}};
};

export const notProjectRelevantRowStyles: Partial<IDetailsRowStyles> = {
	root: {
		backgroundColor: '#d3d3d3',
		color: '#666',
	},
	cell: {
		color: '#666',
	},
};
